// ********************************************************
// Pre-Registration
// Handles stuff like view and submit weights from Pre-Registration.
// ********************************************************

import * as Backend from '@/core/backend'

export async function loadRegistrations (params) {
  const res = await Backend.callApi({
    apiName: 'PreRegistration.LoadRegistrations',
    inputData: {
      Facility: params
    }
  })
  if (!res.failed && res.data !== null) {
    // Sort so newest is top-most
    res.data = res.data.sort((a, b) =>
      (a.CreatedData < b.CreatedData) ? 1 : ((b.CreatedData < a.CreatedData) ? -1 : 0))
  }
  return res
}

export async function loadRegistration (id) {
  const res = await Backend.callApi({
    apiName: 'PreRegistration.LoadRegistration',
    inputData: {
      Id: id
    }
  })
  return res
}

export async function saveRegistration (params) {
  const res = await Backend.callApi({
    apiName: 'PreRegistration.SaveRegistration',
    inputData: {
      PreRegistration: params
    }
  })
  return res
}

export async function printRegistration (id) {
  const res = await Backend.callApi({
    apiName: 'PreRegistration.PrintRegistration',
    inputData: {
      Id: id
    }
  })
  return res
}

export async function userVehicleLicensePlateNo () {
  const res = await Backend.callApi({
    apiName: 'PreRegistration.UserVehicleLicensePlateNo',
    inputData: { }
  })
  return res
}

export async function loadFilteredArticles (params) {
  const res = await Backend.callApi({
    apiName: 'Archive.LoadArticles',
    inputData: {
      Facility: params.facilityNo,
      ArticleNoFilter: params.ArticleNoFilter
    }
  })
  return res
}

export async function loadFacilityData (params) {
  const res = await Backend.callApi({
    apiName: 'PreRegistration.LoadFacilityData',
    inputData: {
      FacilityNo: params.facilityNo,
      CorpName: params.corpName
    }
  })
  return res
}
